import { render, staticRenderFns } from "./LgFinderPageGrupoTipoCaracteristica.vue?vue&type=template&id=0dd1bf14"
import script from "./LgFinderPageGrupoTipoCaracteristica.vue?vue&type=script&lang=js"
export * from "./LgFinderPageGrupoTipoCaracteristica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports